exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._3HAIMzs6{text-align:center;display:block}._13qD1H4G{font-size:12px;font-weight:400;color:#414141;line-height:16px}._3HAIMzs6.zbMT0Sml{padding:50px}._13qD1H4G.zbMT0Sml{font-size:20px}", ""]);

// exports
exports.locals = {
	"component": "_3HAIMzs6",
	"text": "_13qD1H4G",
	"big": "zbMT0Sml"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[hash:base64:8]"}!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist!./src/note/hint/style.less
// module id = 1220
// module chunks = 1